import { css } from "../../../../styled-system/css";
import type { MunicipalCampaignRegion } from "../../../config";
import { t } from "../../../libs/i18n";
import { openUserAuthenticationReregistration } from "../../../libs/sdk";

type Props = {
  regions: MunicipalCampaignRegion[];
};

export const MiyagiMunicipalCampaignBanner = ({ regions }: Props) => {
  const handleReload = () => {
    void openUserAuthenticationReregistration();
  };

  return (
    <section
      className={css({
        bg: "surface.accentPrimaryLight",
        rounded: "xl",
        p: "16px",
        display: "flex",
        flexDir: "column",
        gap: "12px",
        color: "text.secondary",
      })}
    >
      <h2
        className={css({
          textAlign: "center",
          fontWeight: 500,
          color: "text.primary",
        })}
      >
        {t("市町村事業による「みやポ」発行のご案内")}
      </h2>

      <p
        className={css({
          fontSize: "14px",
          lineHeight: "1.6",
        })}
      >
        {t(
          "以下の地域にお住まいの方は、市町村事業で発行されるポイントを受領できます（新規登録3,000ポイントに応募した方も受領可能です）。",
        )}
      </p>

      <div
        className={css({
          display: "flex",
          flexDir: "column",
          gap: "4px",
        })}
      >
        <p
          className={css({
            fontWeight: 500,
            fontSize: "14px",
          })}
        >
          {t("【対象地域と応募期間】")}
        </p>
        {regions.map((region) => (
          <p
            key={region.key}
            className={css({
              fontSize: "14px",
            })}
          >
            ・{region.name}　{region.campaignPeriodText}
          </p>
        ))}
      </div>

      <p
        className={css({
          fontSize: "14px",
          lineHeight: "1.6",
        })}
      >
        {t(
          "応募期間になると、対象者限定で本画面に応募ボタンが現れます。なお、新たに対象地域に転入した方は、応募ボタンが表示されない場合があります。その場合は、下記の「再読込する」ボタンからマイナンバーカードを読み込み直してください。",
        )}
      </p>

      <button
        type="button"
        className={css({
          bg: "surface.accentPrimary",
          rounded: "2xl",
          px: "14px",
          py: "12px",
          color: "white",
          fontWeight: 500,
        })}
        onClick={handleReload}
      >
        {t("再読込する")}
      </button>
    </section>
  );
};
